import { useContext } from 'react';
import { LoadingContext } from '@context';

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  return context;
};
